import { render, staticRenderFns } from "./DOGeneration.vue?vue&type=template&id=524f7412&scoped=true"
import script from "./DOGeneration.vue?vue&type=script&lang=js"
export * from "./DOGeneration.vue?vue&type=script&lang=js"
import style0 from "./DOGeneration.vue?vue&type=style&index=0&id=524f7412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f7412",
  null
  
)

export default component.exports